import {AbstractControl, ValidationErrors} from '@angular/forms';
import {
  formatCnpjDigits,
  formatCpfDigits,
  formatPhoneDigits,
  formatPixKeyForDisplay,
  inferPixKeyKind,
  maskForPixKeyKind,
  PixKeyInferKind,
  validatePixKeyByKind,
} from '@gatewee/utils/helpers/pix-key-infer.helper';

/** @deprecated Prefer {@link PixKeyInferKind} — alias kept for withdrawal call sites. */
export type RecipientInferKind = PixKeyInferKind;

export const inferRecipientKind = inferPixKeyKind;
export const maskForRecipientKind = maskForPixKeyKind;

export {
  formatCnpjDigits,
  formatCpfDigits,
  formatPhoneDigits,
  formatPixKeyForDisplay,
};

/** Maps inferred kind → withdrawal form `pixKeyType` control values (`cpf`/`cnpj`/…). */
export function mapKindToPixKeyType(kind: RecipientInferKind): string {
  switch (kind) {
    case 'cpf':
      return 'cpf';
    case 'cnpj':
      return 'cnpj';
    case 'phone':
      return 'phone';
    case 'email':
      return 'email';
    case 'random':
      return 'random';
    case 'cpf_or_phone':
      return '';
    default:
      return '';
  }
}

/**
 * Same as {@link validatePixKeyByKind}, remapping shared error keys to the
 * withdrawal smart-recipient customMessages (`recipientUnrecognized` / `recipientIncomplete`).
 */
export function validateRecipientByKind(
  raw: string,
  kind: RecipientInferKind,
): ValidationErrors | null {
  const errors = validatePixKeyByKind(raw, kind);
  if (!errors) {
    return null;
  }
  const remapped: ValidationErrors = {};
  for (const [key, value] of Object.entries(errors)) {
    if (key === 'pixKeyUnrecognized') {
      remapped['recipientUnrecognized'] = value;
    } else if (key === 'pixKeyIncomplete') {
      remapped['recipientIncomplete'] = value;
    } else {
      remapped[key] = value;
    }
  }
  return remapped;
}

export {
  formatRecipientAccount,
  formatRecipientAgency,
} from '@gatewee/utils/helpers/format-bank-account-display';

export function validateSmartRecipient(
  control: AbstractControl,
): ValidationErrors | null {
  const raw = String(control.value ?? '').trim();
  return validateRecipientByKind(raw, inferRecipientKind(raw));
}
